import { useImportedStudyStore } from '../../stores/useImportedStudyStore';

export type { ImportedStudyQidoResult } from './importedStudyApi';
export {
  getImportedStudyQidoSearchResults,
  getImportedStudySeriesSearchResults,
  isImportedStudyUID,
} from './importedStudyApi';

type ImportedStudyListener = (studyInstanceUIDs: string[]) => void;

const listeners = new Set<ImportedStudyListener>();

useImportedStudyStore.subscribe((state, previousState) => {
  if (state.studies === previousState.studies) {
    return;
  }

  const previousUIDs = new Set(previousState.studies.map(study => study.studyInstanceUID));
  const addedStudyUIDs = state.studies
    .map(study => study.studyInstanceUID)
    .filter(studyInstanceUID => !previousUIDs.has(studyInstanceUID));

  if (addedStudyUIDs.length) {
    listeners.forEach(listener => listener(addedStudyUIDs));
  }
});

export function registerImportedStudy(record: {
  studyInstanceUID: string;
  studyDate: string;
  studyDescription: string;
  modalities: string;
  numInstances: number;
}): void {
  useImportedStudyStore.getState().addStudies([
    {
      studyInstanceUID: record.studyInstanceUID,
      studyDescription: record.studyDescription,
      studyDate: record.studyDate,
      modalities: record.modalities,
      numInstances: record.numInstances,
    },
  ]);
}

export function getImportedStudyBrowserEntries() {
  return useImportedStudyStore.getState().getBrowserEntries();
}

export function subscribeImportedStudies(listener: ImportedStudyListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyImportedStudiesAdded(studyInstanceUIDs: string[]): void {
  listeners.forEach(listener => listener(studyInstanceUIDs));
}
